import { render } from "./Member_edit.vue?vue&type=template&id=375088bc"
import script from "./Member_edit.vue?vue&type=script&lang=js"
export * from "./Member_edit.vue?vue&type=script&lang=js"
script.render = render

export default script